export default {
    title: `New version available`,
    text: `A major update of Kolsquare has been deployed. Please reload the application to continue using Kolsquare, (only a few seconds will be needed).`,
    button: `Reload`,
};
